// extracted by mini-css-extract-plugin
export default {"labelsCont":"LabelsPopper_labelsCont__qlEON","title":"LabelsPopper_title__OEeU2","labelItemCont":"LabelsPopper_labelItemCont__AJku5","labelTitle":"LabelsPopper_labelTitle__pYi6r"};